// extracted by mini-css-extract-plugin
export var heading = "styles-module--heading--F-uJw";
export var icon = "styles-module--icon--2lWJ8";
export var notice = "styles-module--notice--jNFBa";
export var points = "styles-module--points--SqKQ9";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var warningStatement = "styles-module--warning-statement--Hmtq2";